import * as React from 'react';

import TextBox from '../TextBox';
import Error from '../Error';
import Form from '../Form';

const {
  DIRECTORY_THEME,
} = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/auth`);

const $ST = DIRECTORY_THEME.AUTH_FORM;
export default class AuthForm extends Form {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
        email: this.props.email,
        password: '',
      },
    };

    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    this.initFormData({
      email: this.props.email,
      password: '',
    });
  }

  submitForm(event) {
    event.preventDefault();
    this.props.login(this.state.formData);
  }

  render() {
    const { authPending, error, display } = this.props;
    return (
      <form
        onSubmit={this.submitForm}
        className='login_partial-container bottom-border'
      >
        <p className='form-label-title'>{$ST.PASSWORD}</p>
        <TextBox
          name='password'
          type='password'
          placeholder={$ST.ENTER_PASSWORD}
          onChange={(value) => this.setField('password', value)}
          value={this.state.formData.password}
        />
        <Error data={error} field='password' />
        {display && (
          <button
            type='submit'
            className='button login_partial-container__login-button'
            disabled={authPending || this.state.formData.password.length === 0}
          >
            {$ST.SUBMIT}
          </button>
        )}
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/captchaAuth/AuthForm.js